import React, { Suspense } from "react";
import { withTranslation } from "react-i18next";
import ForgotUserName from "./ForgotUserName";
import ForgotPassword from "./ForgotPassword";
// import SuccessMessage from "./_SuccessMessage";

class Tabs extends React.Component {
  constructor(props) {
    super(props);
    // console.log(" Tabs ====> this.props.clientInfo " + this.props.clientInfo)
    this.state = {
      isActive: "1",
      data: [
        {
          id: "1",
          tabIntro: "forgot_password_intro_msg_general",
          tabTitle: "forgot_password_tab",
          tabContent: (
            <ForgotPassword
              setShowSuccessMsg={this.props.setShowSuccessMsg}
              setMessageDetails={this.props.setMessageDetails}
              clientId={this.props.clientId}
              redirectURL={this.props.redirectURL}
              clientInfo={this.props.clientInfo}
              isThirdParty={this.props.isThirdParty}
              isConsumer={this.props.isConsumer}
            />
          ),
        },
        {
          id: "2",
          tabIntro: "forgot_username_intro_msg_general",
          tabTitle: "forgot_username_tab",
          tabContent: (
            <ForgotUserName
              setShowSuccessMsg={this.props.setShowSuccessMsg}
              setMessageDetails={this.props.setMessageDetails}
              clientId={this.props.clientId}
              redirectURL={this.props.redirectURL}
              clientInfo={this.props.clientInfo}
              isThirdParty={this.props.isThirdParty}
              isConsumer={this.props.isConsumer}
            />
          ),
        },
      ],
      showSuccessMsg: false,
    };
    this.changeActive = this.changeActive.bind(this);
  }

  changeActive(ev) {
    this.setState({ isActive: ev.target.getAttribute("data-tab") });
  }

  setShowSuccessMsg = (param) => {
    console.log("tabs param: " + param);
    this.setState({
      showSuccessMsg: param,
    });
  };

  render() {
    const { t } = this.props;
    var listIntro = this.state.data.map((item) =>
      this.state.isActive === item.id ? (
        <TabIntro
          key={item.id}
          dataTab={item.id}
          content={t(item.tabIntro)}
          isActive={this.state.isActive}
        />
      ) : (
          <TabIntro
            key={item.id}
            dataTab={item.id}
            content={t(item.tabIntro)}
            isActive={this.state.isActive}
            style={{ display: "none" }}
          />
        )
    );
    var listTitle = this.state.data.map((item) => (
      <TabTitle
        key={item.id}
        isActive={this.state.isActive}
        onClick={this.changeActive}
        dataTab={item.id}
        title={t(item.tabTitle)}
      />
    ));
    var listContent = this.state.data.map((item) =>
      this.state.isActive === item.id ? (
        <TabContent key={item.id} dataTab={item.id} content={item.tabContent} />
      ) : (
          <TabContent
            key={item.id}
            style={{ display: "none" }}
            dataTab={item.id}
            content={item.tabContent}
          />
        )
    );
    return (
      <div>
        {!this.state.showSuccessMsg && (
          <section className="login_form">
            <div className="introTextContainer mb-3">{listIntro}</div>
            <br />
            <div className="tabs">
              <ul className="tabs-titles mb-4">{listTitle}</ul>
              <div className="tab-content">{listContent}</div>
            </div>
          </section>
        )}
        {/* {this.state.showSuccessMsg && <SuccessMessage />} */}
        {this.state.showSuccessMsg}
      </div>
    );
  }
}

function TabIntro(props) {
  return (
    <h3 style={props.style} data-tab={props.isActive}>
      {props.content}{" "}
    </h3>
  );
}

function TabTitle(props) {
  return props.isActive === props.dataTab ? (
    <li
      onClick={props.onClick}
      className="tab-title tab-title--active"
      data-tab={props.dataTab}
    >
      {props.title}
    </li>
  ) : (
      <li onClick={props.onClick} className="tab-title" data-tab={props.dataTab}>
        {props.title}
      </li>
    );
}

function TabContent(props) {
  return (
    <div style={props.style} data-tab={props.dataTab}>
      {props.content}
    </div>
  );
}

export default withTranslation()(Tabs);
